module.exports = __webpack_public_path__ + "static/img/add_teacher_title.5d51532e.png";